'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /Users/jlaster/src/mozilla/devtools-core/packages/devtools-source-map/~/querystring/index.js
// module id = 14
// module chunks = 1